import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7c579ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "protocolCards",
  ref: "cards"
}
const _hoisted_4 = { class: "row pb-1" }
const _hoisted_5 = { class: "row pt-2 pb-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Recommend")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Submit a protocal ")

import { Protocol } from "@/models/Protocol";
import { NotifiUser } from "@/models/NotifiUser";
import { userModule } from "@/store/user";
import Moralis from "moralis";
import { computed, inject, onMounted, ref } from "vue";
import ProtocolInfo from "@/components/ProtocolInfo.vue";
import { SiteStatus } from "@/notifi_types";
import { useAppStore } from "@/store/pinia_app";
import { useProtocolsStore } from "@/store/pinia_protocols";


/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  props: {
  showSearch: { type: Boolean, required: false, default: true },
  showVote: { type: Boolean, required: false, default: false },
  showSubscribe: { type: Boolean, required: false, default: false },
  showFavorites: { type: Boolean, required: false, default: true },
  showSearchFavorites: { type: Boolean, required: false, default: true },
  showUserInfo: { type: Boolean, required: false, default: false },
  autoSelect: { type: Boolean, required: false, default: false },
  simpleList: { type: Boolean, required: false, default: false },
  simpleMulti: { type: Boolean, required: false, default: true },
  allowSelect: { type: Boolean, required: false, default: true },
  showRequested: { type: Boolean, required: false, default: false },
  showAdd: { type: Boolean, required: false, default: false },
  manager: { type: Boolean, required: false, default: false },
},
  emits: ["selection", "subscribe", "add"],
  setup(__props, { emit }) {

const props = __props




const appStore = useAppStore();

const intSearch = ref("");
const intSearchFavorites = ref(appStore.protocolSearchFavorites);
const selectedProtocol = ref<Protocol | undefined>(undefined);
const selectedProtocols = ref<Protocol[]>([]);
const query = ref<any>(undefined);
const rawProtocols = ref<Protocol[]>([]);
const filteredProtocols = ref<Protocol[]>([]);
const queryLimit = ref<number>(20);
const loading = ref(false);
const showAdder = ref(props.showAdd);

onMounted(async () => {
  if (props.showUserInfo) {
    userModule.fetchUserTokens();
  }
  fetchProtocols();
});

const protocols = computed((): Protocol[] => {
  let prots = filteredProtocols.value;
  if (search.value) {
    const result = prots.filter((e: Protocol) => {
      const idx = e.name.toLowerCase().indexOf(search.value.toLowerCase());
      return idx != -1;
    });
    prots = result;
  }
  return prots;
});

const search = computed({
  get(): string {
    return intSearch.value;
  },
  set(newVal: string) {
    intSearch.value = newVal;
    //this.rawProtocols.length = 0;
    //this.fetchProtocols();
  },
});

const searchFavorites = computed({
  get(): boolean {
    return intSearchFavorites.value;
  },
  set(newVal: boolean) {
    intSearchFavorites.value = newVal;
    appStore.protocolSearchFavorites = newVal;
    fetchProtocols(true);
  },
});

const select = (aProtocol: Protocol): void => {
  selectedProtocol.value = aProtocol;
  emit("selection", selectedProtocol.value);
};
const subscribe = (aProtocol: Protocol): void => {
  emit("subscribe", aProtocol);
};
const selectionChange = () => {
  emit("selection", selectedProtocols.value);
};
const unselect = (prot: Protocol) => {
  selectedProtocols.value = selectedProtocols.value.filter((v) => {
    return v.id !== prot.id;
  });
  selectionChange();
};
const setSearch = (s: string) => {
  console.log("Set Search");
  search.value = s;
};
const appendProtocols = async (): Promise<void> => {
  //console.log("Append");
  fetchProtocols();
};
const fetchProtocols = async (refresh?: boolean): Promise<void> => {
  const protocolsStore = useProtocolsStore();
  loading.value = true;
  if (searchFavorites.value) {
    const u = Moralis.User.current();
    const rel = u.relation("FavoriteProtocols");
    query.value = rel.query();
  } else {
    query.value = new Moralis.Query(Protocol);
  }
  if (!props.showRequested) {
    query.value.notEqualTo("siteStatus", SiteStatus.requested);
  }
  query.value.include("ProtocolStatus");
  query.value.limit(queryLimit.value);
  if (!refresh) {
    query.value.skip(rawProtocols.value.length);
  }
  querySubscribe(query.value);
  let prots = await query.value.find();
  if (refresh == true) {
    rawProtocols.value.length = 0;
  }
  rawProtocols.value.push(...prots);
  let res: Protocol[] = [];
  if (props.manager) {
    //if (user && (await user.isAdmin())) {
    // eslint-disable-next-line no-constant-condition
    if (false) {
      res.push(...prots);
    } else {
      for (let i = 0; i < prots.length; i++) {
        let man = await prots[i].managerOf();
        if (man) {
          res.push(prots[i]);
        }
      }
    }
  } else {
    res = rawProtocols.value;
  }

  if (props.autoSelect && res.length == 1) {
    select(res[0]);
  }
  let res2: Protocol[] = [];
  if (search.value) {
    const test = search.value.toLowerCase();
    for (let i = 0; i++; i < res.length) {
      if (res[i].name.search(test) != -1) {
        res2.push(res[i]);
      }
    }
  } else {
    res2 = res;
  }
  filteredProtocols.value = res2;
  loading.value = false;
};

const refresh = (): void => {
  fetchProtocols(true);
};

const querySubscribe = async (query: any) => {
  const protocol = await query.subscribe();
  const safeManagerPush = async (prot: Protocol) => {
    if (props.manager) {
      if (await prot.managerOf()) {
        rawProtocols.value.push(prot);
      }
    } else {
      rawProtocols.value.push(prot);
    }
  };
  protocol.on("create", async (prot: Protocol) => {
    safeManagerPush(prot);
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protocol.on("update", (sub: Protocol) => {
    const index = rawProtocols.value.findIndex((e) => e.id == sub.id);
    if (index > -1) {
      rawProtocols.value.splice(index, 1, sub);
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protocol.on("enter", (prot: Protocol) => {
    safeManagerPush(prot);
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protocol.on("leave", (sub: Protocol) => {
    const index = rawProtocols.value.findIndex((e) => e.id == sub.id);
    if (index > -1) {
      rawProtocols.value.splice(index, 1);
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protocol.on("delete", (sub: Protocol) => {
    const index = rawProtocols.value.findIndex((e) => e.id == sub.id);
    if (index > -1) {
      rawProtocols.value.splice(index, 1);
    }
  });
  protocol.on("close", () => {
    console.log("Protocols Subscription closed");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_infinite_scroll = _resolveComponent("va-infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.simpleList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_va_select, {
            options: _unref(protocols),
            label: "Protocol",
            "track-by": "id",
            "text-by": "name",
            modelValue: selectedProtocols.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((selectedProtocols).value = $event)),
              selectionChange
            ],
            multiple: __props.simpleMulti,
            searchable: "",
            clearable: "",
            onUpdateSearch: setSearch
          }, {
            content: _withCtx(({ value }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (chip) => {
                return (_openBlock(), _createBlock(_component_va_chip, {
                  key: chip,
                  size: "small",
                  class: "mr-1 ml-1",
                  closeable: "",
                  "onUpdate:modelValue": ($event: any) => (unselect(chip))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(chip.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onUpdate:modelValue"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["options", "modelValue", "multiple"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (__props.showSearch)
              ? (_openBlock(), _createBlock(_component_va_input, {
                  key: 0,
                  class: "flex xs6 sm9",
                  label: "Search Names",
                  modelValue: _unref(search),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(search) ? (search).value = $event : null))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (__props.showSearchFavorites)
              ? (_openBlock(), _createBlock(_component_va_checkbox, {
                  key: 1,
                  class: _normalizeClass(["flex xs4 sm2", __props.showSearch ? '' : 'offset--xs9 offset--sm9']),
                  label: "Favorites?",
                  modelValue: _unref(searchFavorites),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchFavorites) ? (searchFavorites).value = $event : null))
                }, null, 8, ["class", "modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["flex xs2 sm1 float-right", 
            __props.showSearchFavorites || __props.showSearch ? '' : 'offset--xs9 offset--sm9'
          ])
            }, [
              _createVNode(_component_va_button, {
                icon: "refresh",
                color: "secondary",
                onClick: refresh
              })
            ], 2)
          ]),
          _createVNode(_component_va_infinite_scroll, { load: appendProtocols }, {
            default: _withCtx(() => [
              _createVNode(_component_va_inner_loading, {
                loading: loading.value,
                size: 60
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(protocols), (protocol) => {
                      return (_openBlock(), _createBlock(ProtocolInfo, {
                        key: protocol.id,
                        protocol: protocol,
                        selected: selectedProtocol.value == protocol,
                        showVote: __props.showVote,
                        showUserInfo: __props.showUserInfo,
                        showFavorites: __props.showFavorites,
                        allowSelect: __props.allowSelect,
                        showSubscribe: __props.showSubscribe,
                        displayMode: "narrow",
                        onSelected: select,
                        onSubscribe: subscribe
                      }, null, 8, ["protocol", "selected", "showVote", "showUserInfo", "showFavorites", "allowSelect", "showSubscribe"]))
                    }), 128)),
                    (!loading.value && showAdder.value)
                      ? (_openBlock(), _createBlock(_component_va_card, {
                          key: 0,
                          href: "#",
                          class: "flex mb-1 xs12 sm4 lg3 xl2",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('add')), ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_card_title, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_va_chip, null, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_va_card_content, { style: {} }, {
                              default: _withCtx(() => [
                                _hoisted_7,
                                _createVNode(_component_va_icon, {
                                  name: "add",
                                  size: 80,
                                  color: "primary"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ], 512))
  ]))
}
}

})